export default {
    '#99567B': {
        secondary_color: '#F5E4EE',
        medium_color: '#D4A5BE',
        text_color: '#99567B',
    },
    '#7155C6': {
        secondary_color: '#E4DCFF',
        medium_color: '#B8AAE3',
        text_color: '#7155C6',
    },
    '#3982BF': {
        secondary_color: '#D2E9FC',
        medium_color: '#8FBBE1',
        text_color: '#387BB3',
    },
    '#14A99F': {
        secondary_color: '#D7F7F5',
        medium_color: '#8BD7D2',
        text_color: '#01857C',
    },
    '#A8C009': {
        secondary_color: '#EDF2C7',
        medium_color: '#D3DF84',
        text_color: '#6D7D00',
    },
    '#FF981A': {
        secondary_color: '#FFF8CB',
        medium_color: '#FFCB8D',
        text_color: '#B26200',
    },
    '#E2618F': {
        secondary_color: '#FFEEF4',
        medium_color: '#FFBAD2',
        text_color: '#C24E77',
    },
    '#2848B7': {
        secondary_color: '#D2DAF7',
        medium_color: '#9BADEF',
        text_color: '#2848B7',
    },
    '#CE8A1E': {
        secondary_color: '#F5E5CB',
        medium_color: '#E8BE7C',
        text_color: '#A3690A',
    },
    '#F97253': {
        secondary_color: '#FFE2DB',
        medium_color: '#FCC3B6',
        text_color: '#C75136',
    },
    '#F6D606': {
        secondary_color: '#FFF7C2',
        medium_color: '#FCEC83',
        text_color: '#82764F',
    },
    '#6EE016': {
        secondary_color: '#E1F8CF',
        medium_color: '#BBF58E',
        text_color: '#3B8700',
    },
    '#05F2BF': {
        secondary_color: '#D5FFF6',
        medium_color: '#ACFDEB',
        text_color: '#008568',
    },
    '#1C73FF': {
        secondary_color: '#DEEBFF',
        medium_color: '#BED7FF',
        text_color: '#166EFA',
    },
    '#A843DF': {
        secondary_color: '#F5E3FF',
        medium_color: '#EDCDFE',
        text_color: '#A843DF',
    },
} as Record<
    string,
    { secondary_color: string; medium_color: string; text_color: string }
>;
